module.exports = __webpack_public_path__ + "img/M2_MS_16.277b8ff5.png";